import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "P", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "L", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "H", -1)
const _hoisted_5 = { class: "action_column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_VehicleDialog = _resolveComponent("VehicleDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      showDelete: false,
      showSave: false,
      title: _ctx.$t('vehicle.list.title')
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('add'),
          icon: "pi pi-plus",
          onClick: _ctx.onNew
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_DataTable, {
      value: _ctx.dataset,
      rows: 10,
      "rows-per-page-options": [10, 20, 50, 100],
      paginator: true,
      "auto-layout": "",
      "striped-rows": "",
      "row-hover": "",
      loading: _ctx.isLoading,
      onRowClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEdit($event.data)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "icon",
          header: _ctx.$t('vehicle.icon')
        }, {
          body: _withCtx(({data}) => [
            _createElementVNode("i", {
              class: _normalizeClass(`fas fa-${data.icon}`)
            }, null, 2)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "name_it",
          header: _ctx.$t('vehicle.name'),
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "note",
          header: _ctx.$t('vehicle.note')
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('vehicle.loading_platform')
        }, {
          body: _withCtx(({data}) => [
            _hoisted_2,
            _createTextVNode(_toDisplayString(data.l1) + " - ", 1),
            _hoisted_3,
            _createTextVNode(_toDisplayString(data.l2) + " - ", 1),
            _hoisted_4,
            _createTextVNode(_toDisplayString(data.l3), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('vehicle.max_weight')
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.weight), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('actions'),
          class: "column-header-right",
          style: {"width":"100px"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-pencil",
                class: "p-button-warning",
                onClick: ($event: any) => (_ctx.onEdit(data))
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('edit'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-trash",
                class: "p-button-danger",
                onClick: ($event: any) => (_ctx.onDelete(data))
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('delete'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value", "loading"]),
    _createVNode(_component_VehicleDialog, {
      autoZIndex: false,
      baseZIndex: 80,
      show: _ctx.showDialog,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog = $event)),
      vehicle: _ctx.vehicleInEdit,
      "onUpdate:vehicle": _cache[2] || (_cache[2] = ($event: any) => (_ctx.vehicleInEdit = $event)),
      onDialogSave: _ctx.onDialogSave,
      onDialogCancel: _ctx.onDialogCancel
    }, null, 8, ["show", "vehicle", "onDialogSave", "onDialogCancel"])
  ]))
}